<app-concierge-banner />

<router-outlet />

<app-notifications-panel />

<app-mfa-challenge />

<p-toast position="top-right" />

<app-consent-banner />

@if (biometric.locked()) {
  <app-biometric-lock />
}
